
import Vue, { PropType } from 'vue';
export default Vue.extend({
	name: 'ValidationAlert',
	props: {
		message: {
			type: String as PropType<string>,
			default: '',
			required: true
		}
	}
});
